/* PetMotionStore custom sections — slider + tabs (no dependencies) */
(function () {
  function initSlider(root) {
    if (root.dataset.pmInit) return;
    root.dataset.pmInit = '1';
    var track = root.querySelector('.pm-slider-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.pm-slide'));
    if (slides.length <= 1) return;
    var dotsWrap = root.querySelector('.pm-slider-dots');
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }
    var current = 0;
    var fade = root.classList.contains('pm-trans--fade');
    function setCurrent(i) {
      current = i;
      dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
    }
    function go(i) {
      current = (i + slides.length) % slides.length;
      if (fade) { slides.forEach(function (sl, si) { sl.classList.toggle('is-active', si === current); }); }
      else { track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' }); }
      setCurrent(current);
    }
    var prev = root.querySelector('.pm-slider-arrow.prev');
    var next = root.querySelector('.pm-slider-arrow.next');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    // keep dots in sync while scrolling/swiping
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== current) setCurrent(Math.max(0, Math.min(slides.length - 1, idx)));
      });
    });
    setCurrent(0);
    // autoplay
    var delay = parseInt(root.dataset.pmAutoplay, 10);
    if (delay && delay > 0) {
      var timer = setInterval(function () { go(current + 1); }, delay);
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', function () { timer = setInterval(function () { go(current + 1); }, delay); });
    }
  }

  function initTabs(root) {
    if (root.dataset.pmInit) return;
    root.dataset.pmInit = '1';
    var btns = Array.prototype.slice.call(root.querySelectorAll('.pm-tab-btn'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.pm-tab-panel'));
    if (!btns.length) return;
    function activate(i) {
      btns.forEach(function (b, bi) { b.setAttribute('aria-selected', bi === i ? 'true' : 'false'); });
      panels.forEach(function (p, pi) { p.classList.toggle('is-active', pi === i); });
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { activate(i); }); });
    activate(0);
  }

  function gridOf(root) {
    return root.querySelector('.pm-coll-grid, .pm-prod-grid, .pm-testi-grid, .pm-gallery-grid, .pm-feat-grid');
  }
  function initCarousel(root) {
    if (root.dataset.pmCar) return;
    var track = gridOf(root);
    if (!track) return;
    root.dataset.pmCar = '1';
    function gap() { return parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) || 16; }
    function page() { return track.clientWidth; }
    var prev = root.querySelector('.pm-carousel-arrow.prev');
    var next = root.querySelector('.pm-carousel-arrow.next');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page() * 0.9, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: page() * 0.9, behavior: 'smooth' }); });
    var dotsWrap = root.querySelector('.pm-carousel-dots');
    if (dotsWrap) {
      var pages = Math.max(1, Math.ceil((track.scrollWidth - 2) / page()));
      dotsWrap.innerHTML = '';
      if (pages > 1) {
        for (var p = 0; p < pages; p++) {
          (function (p) {
            var b = document.createElement('button');
            b.type = 'button'; b.setAttribute('aria-label', 'Page ' + (p + 1));
            b.addEventListener('click', function () { track.scrollTo({ left: p * page(), behavior: 'smooth' }); });
            dotsWrap.appendChild(b);
          })(p);
        }
        var dots = dotsWrap.querySelectorAll('button');
        var raf;
        track.addEventListener('scroll', function () {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / page());
            dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
          });
        });
        dots[0].setAttribute('aria-current', 'true');
      }
    }
    var delay = parseInt(root.dataset.pmAutoplay, 10);
    if (delay > 0) {
      var pause = root.dataset.pmPause !== '0';
      var tick = function () {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: page() * 0.9, behavior: 'smooth' });
      };
      var timer = setInterval(tick, delay);
      if (pause) {
        root.addEventListener('mouseenter', function () { clearInterval(timer); });
        root.addEventListener('mouseleave', function () { timer = setInterval(tick, delay); });
      }
    }
  }

  var revealObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pm-in'); revealObs.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }) : null;
  function initReveal(scope) {
    if (!revealObs) return;
    (scope || document).querySelectorAll('.pm-reveal:not(.pm-in)').forEach(function (n) { revealObs.observe(n); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.pm-slider').forEach(initSlider);
    (scope || document).querySelectorAll('.pm-tabs').forEach(initTabs);
    (scope || document).querySelectorAll('.pm-is-carousel').forEach(initCarousel);
    initReveal(scope);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // Shopify theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    el.querySelectorAll('.pm-slider').forEach(function (n) { n.dataset.pmInit = ''; initSlider(n); });
    el.querySelectorAll('.pm-tabs').forEach(function (n) { n.dataset.pmInit = ''; initTabs(n); });
    el.querySelectorAll('.pm-is-carousel').forEach(function (n) { n.dataset.pmCar = ''; initCarousel(n); });
    initReveal(el);
  });
})();
